import React, {ReactNode} from 'react';
import './Internship.css'
import "react-quill/dist/quill.snow.css";
import {Link} from "react-router-dom";
import {useRecoilState} from "recoil";
import {zoomedAtom} from "../atoms";

import {Carousel} from "react-responsive-carousel";
const WorkShop = ({
                      image,
                      title,
                      subtitle,
                      description,

                  }: {
    image?: { url: string, title: string },
    title?: ReactNode,
    subtitle: ReactNode,
    description: ReactNode

}) => {
    const [, setZoomed] = useRecoilState(zoomedAtom);
    return <> {title && <p className="WorkShopTitle">{title}</p>}<div className="WorkShopElement">
        <div className="WorkShopText">

            <p className="WorkShopSubTitle">{subtitle}</p>
            <div className="WorkShopImageWrapper">{image&&<img  onClick={()=>setZoomed(image.url)} alt={image.title} src={image.url}/>}</div>
            <p>{description}</p>
        </div>
    </div></>;

}
const images=[{url:"atest1.jpeg",title:'atelier page 1'},{url:'atest2.jpeg',title: 'atelier page 2'}]
function Workshop() {
    const [, setZoomed] = useRecoilState(zoomedAtom);


    return (
        <div className="Internship">
            <h1>ATELIERS DE VANNERIE A COISE-SAINT-JEAN-PIED-GAUTHIER</h1>


            <h2>Des ateliers découvertes sont organisés tous les deux mois environ, pour enfants, ados et adultes.</h2>

            <div
                className="InternshipSpecialText"><span>Ces activités étant organisées par l’association <b>Art’Artouille</b>, une <b>cotisation annuelle de 5
                euros</b> est à régler pour y participer.</span> <span style={{textAlign: 'center'}}> <a
                href='https://www.facebook.com/p/ArtAtouille-100057263057505/'><img
                style={{mixBlendMode: 'multiply', width: '100px'}}
                src={'/arttatouille.jpeg'}/></a></span></div>

            <p>Pour vous inscrire ou pour plus d'informations vous pouvez m'envoyer un message (<Link
                style={{fontSize: '18px'}} to={'/contact'}>contact</Link>) ou m'appeler au <a style={{fontSize: '18px'}}
                                                                                              href='tel:0644921850'><u>06
                44 92 18 50</u></a></p>
            <p>Le prix des ateliers comprend la récolte et la préparation de la matière première et le prêt des outils. Une collation sera offerte aux participant.e.s qui repartiront chacun.e avec l’objet qui aura été réalisé.</p>

            <p>Un atelier adultes peut accueillir jusqu’à 8 personnes sur les techniques simples et 6 personnes sur les
                techniques plus complexes</p>

            <p>Un atelier enfants peut accueillir jusqu’à 4 personnes, participation en autonomie à partir de l’âge de 7
                ans. Chaque enfant étant différent, vous pouvez me contacter pour échanger sur vos souhaits, que ce soit
                pour l’accompagner après 7 ans ou pour y participer avec lui ou elle avant cet âge.</p>

            <p>Les adolescent.e.s sont les bienvenu.e.s sur le groupe qui leur conviendra le mieux, enfant ou adultes</p>
            {/*<WorkShop
                title={<>Ateliers du mois de février 2025 :</>}
                subtitle={<>Atelier adultes : <b>samedi 15 février</b> de 9h à 12h à Coise (73800)</>}
                description={<>Suspension végétale en
                    clématite sauvage écorcée</>}
                image={{url: '/suspension_2.jpg', title: 'corbeille allongée'}}

            />*/}
            {/*  <WorkShop
            subtitle={<>Atelier enfants : <b>SAMEDI 12 AVRIL</b> de 9H30 à 16H30 à Coise (73800)</>}
            description={<>Réalisation d’un petit panier en osier brut pour
                aller à la chasse aux œufs de Pâques ! <br/>  Prix : 65 euros</>}
            image={{url: '/paques.jpeg', title: 'paques'}}

        />*/}
            <div className={"CarrouselWorkshop"} style={{display: 'flex', flexDirection: 'column' }}>
                <Carousel
                    infiniteLoop={true}
                    autoPlay={true}
                    statusFormatter={() => ''}
                    transitionTime={1000}
                    interval={7000}
                    onClickItem={(i: number) => {
                        setZoomed(images[i].url)
                    }}
                    renderThumbs={() => []}>
                    {images.map((e: { url: string, title: string }) => <div key={e.title}>
                        <img alt={e.title} src={e.url}/>
                    </div>)}

                </Carousel>

            </div>

            {(new Date() < new Date('30 october 2025')) && <WorkShop
                title={<>Ateliers de mois d'octobre 2025 :</>}
                subtitle={<>Atelier vannerie du <b>SAMEDI 25 OCTOBRE 2025. </b></>}
                description={<>Création d'une fleur en osier, à planter sur un bâton pour mettre au jardin ou pour
                    décorer les murs... De 10h à 12h pour les adultes, 35 euros. De 14h à 16h pour les enfants 30 euros.
                    + 5 euros de cotisation annuelle à Art'Atouille.</>}
                image={{url: '/flow.jpeg', title: 'helico'}}
            />}{(new Date() < new Date('25 november 2025')) && <WorkShop
                title={<>Atelier du moi de novembre 2025</>}
                subtitle={<>Atelier vannerie du <b> DIMANCHE 23 NOVEMBRE 2025</b></>}
                description={<>Adultes de 9h à 12h - Enfants de 14h à 17h à Coise (73800)<br/>
                    Création d'un sapin à déposer sur la table de Noël. Visuel à venir.
                    Prix adultes : 40 euros , prix enfants : 35 euros
                    + adhésion annuelle Art'Atouille</>}
                image={{url: '/deco.jpeg', title: 'sapin'}}
            />}{(new Date() < new Date('12 january 2026')) && <WorkShop
                title={<>Atelier du moi de janvier 2026</>}
                subtitle={<>Atelier vannerie du <b> SAMEDI 10 JANVIER 2026</b></>}
                description={<>Tressage en osier d'une corbeille ronde galbée. Pour découvrir les techniques de base de la vannerie d'osier traditionnelle.
                    Prix : 85 euros + adhésion annuel Art'Atouille</>}
                image={{url: '/corbst.jpeg', title: 'corbeille'}}
            />}
            {/* <WorkShop
                title={<>Ateliers de mois de juin 2025 :</>}
                subtitle={<>Atelier adultes <b>SAMEDI 14 JUIN 2025</b> de 9h à 17h à Coise (73800) </>}
                description={<>Tressage en osier brut d'un panier hélicoïdale avec anse en bois. Le tressage du bas sera plus simple que celui de la photo pour pouvoir le faire en une journée.<br/>  Prix : 85 euros + adhésion annuel Art'Atouille</>}
                image={{url: '/helico_stage.jpeg', title: 'helico'}}
            />*/}
            {/*
            <WorkShop
                title={<>Ateliers de mois de novembre 2024 :</>}
                subtitle={<>Atelier adultes : <b>samedi 23 novembre</b> de 9h à 12h</>}
                description={<>Création d'une mangeoire à oiseaux. Cornouiller sanguin et clématite sauvages
                    principalement. Autres végétaux possibles en fonction de la récolte</>}
                image={{url: '/ws_nv_2.jpeg', title: 'mangeoire à oiseaux'}}
            /> <WorkShop
                subtitle={<>Atelier enfants : <b> mercredi 13 novembre</b> de 9h à 12h</>}
                description={<>Création d'une mangeoire à oiseaux. Cornouiller sanguin et clématite sauvages
                    principalement. Autres végétaux possibles en fonction de la récolte</>}

                image={{url: '/ws_nv_1.jpeg', title: 'mangeoire à oiseaux enfant'}}

            />

            <WorkShop
                title={<>Ateliers du mois de décembre :</>}
                subtitle={<>Atelier adultes : <b>dimanche 8 décembre</b> de 9h à 12h</>}
                description={<>Création de décorations de Noël en osier : Sapin de Noël, anneau, en suspensions individuelles ou guirlandes.</>}
                image={{url: '/deco_noel.jpeg', title: 'deco noel'}}


            /> <WorkShop
                subtitle={<>Atelier enfants : <b> mercredi 4 décembre</b> de 9h à 12h</>}
                description={<>Création de décorations de Noël en osier : Sapin de Noël, anneau, en suspensions individuelles ou guirlandes. Si temps le permet : étoiles.</>}
                image={{url: '/deco_noel.jpeg', title: 'mangeoire à oiseaux enfant'}}

            />*/}


        </div>
    );
}

export default Workshop;
